import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';
import bottom_img2 from '../../../assets/img/home_img_bottom2.png';


class CustomDev extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Professional Services </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>WE CREATE JAW-DROPPING CUSTOM XR (AR/VR/360) EXPERIENCES</b>
                      <br></br>
                      With our team’s wealth of experience, industry knowledge, and technology stack, 
                      we’re uniquely suited to work with global organizations to tackle a wide range of challenges – 
                      from product development to scaled deployment.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Technologies:</b>
                      <br></br>
                      1. 3D Web <br></br>
                      2. Augmented Reality (AR) <br></br>
                      3. Virtual Reality (VR) <br></br>
                      4. Mixed Reality (MR) <br></br>
                      5. 3 Degrees of Freedom (3DoF) <br></br>
                      6. 6 Degrees of Freedom (6DoF) <br></br>
                      7. 360° Video <br></br>
                      8. Volumetric Capture <br></br>
                      9. 3D Modeling <br></br>
                      10. Computer Vision <br></br>
                      11. Facial Recognition <br></br>
                      l2. Virtual Try On <br></br>
                      l3. Haptics & Peripherals <br></br>
                      l4. Hand Tracking <br></br>
                      l5. Spatial Audio <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Hardware:</b>
                      <br></br>
                      1. Apple Vision Pro <br></br>
                      2. HTC Vive <br></br>
                      3. Magic Leap <br></br>
                      4. Microsoft Hololens <br></br>
                      5. Oculus Quest <br></br>
                      6. Oculus Quest Pro <br></br>
                      7. Samsung Gear VR <br></br>
                      8. Insta360 Pro Cameras <br></br>
                      9. Intel RealSense Cameras <br></br>
                      10. Azure Kinect Camera <br></br>
                      11. Mobile Phones/Tablets <br></br>
                      l2. Matterport <br></br>               
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <a href="https://www.icomputinglabs.in/#/theme/home"> icomputinglabs family:</a>
                      <br></br>
                      1. <a href="https://www.icomputinglabs.in/#/theme/competencies-vr">Competencies VR </a> and Competencies Center, a one stop solution for all your educational needs <br></br>
                      2. <a href="https://www.icomputinglabs.in/#/theme/spotlight-ar">Spotlight AR </a> and Spotlight Center, a one stop solution for all your retail business needs <br></br>
                      <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Want to know how immersive computing is already transforming your industry? </b>
                    </h6>
                    <a href="/contact"> Contact us. </a>
                  </Col>  

                </Row>
        
  {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features & Roadmap</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >Solutions</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Professional Services</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/pricing"><div className = "font-size-10" >Pricing</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default CustomDev;



// WEBPACK FOOTER //
// ./src/views/Pages/CustomDev/CustomDev.js